// api/ApprovalRequest/index.ts
import http from "api/https";

export interface ApprovalRequestData {
  id?: number;
  bga_application_number?: string;
  organization_id: number;
  applicant_name?: string;
  approval_type?: string;
  current_status?: string;
  priority?: string;
  operator_id?: number;
  received_date?: string;
  deadline_date?: string;
  completed_date?: string;
  created_at?: string;
  updated_at?: string;
  created_by?: number;
  updated_by?: number;
}

export interface SearchApprovalRequestParams {
  bga_application_number?: string;
  applicant_name?: string;
  priority?: string;
  status?: string;
  operator_id?: number | string;
  received_date_from?: string;
  received_date_to?: string;
}

// Получить список всех заявок
export const getApprovalRequests = (): Promise<any> => {
  return http.get("/ApprovalRequest/GetAllMyOrg");
};

// Получить одну заявку по ID
export const getApprovalRequest = (id: number): Promise<any> => {
  return http.get(`/ApprovalRequest/GetOneById?id=${id}`);
};

// Создать новую заявку
export const createApprovalRequest = (data: ApprovalRequestData): Promise<any> => {
  return http.post(`/ApprovalRequest/Create`, data);
};

// Обновить заявку
export const updateApprovalRequest = (data: ApprovalRequestData): Promise<any> => {
  return http.put(`/ApprovalRequest/Update`, data);
};

// Удалить заявку
export const deleteApprovalRequest = (id: number): Promise<any> => {
  return http.remove(`/ApprovalRequest/Delete?id=${id}`, {});
};

export const changeStatus = (id: number, code: string): Promise<any> => {
  var data = {
    id: id,
    status: code,
  }
  return http.post(`/ApprovalRequest/changeStatus`, data);
};

// Поиск заявок по фильтрам
export const searchApprovalRequests = (params: SearchApprovalRequestParams): Promise<any> => {
  const queryParams = new URLSearchParams();

  if (params.bga_application_number) {
    queryParams.append('bga_application_number', params.bga_application_number);
  }
  if (params.applicant_name) {
    queryParams.append('applicant_name', params.applicant_name);
  }
  if (params.priority) {
    queryParams.append('priority', params.priority);
  }
  if (params.priority) {
    queryParams.append('priority', params.priority);
  }
  if (params.status) {
    queryParams.append('status', params.status);
  }
  if (params.operator_id) {
    queryParams.append('operator_id', params.operator_id.toString());
  }
  if (params.received_date_from) {
    queryParams.append('received_date_from', params.received_date_from);
  }
  if (params.received_date_to) {
    queryParams.append('received_date_to', params.received_date_to);
  }

  return http.get(`/ApprovalRequest/Search?${queryParams.toString()}`);
};

// Получить список операторов
export const getOperators = (): Promise<any> => {
  return http.get("/Operator/GetAll");
};

// Дополнительные методы
export const getApprovalRequestsByOrganization = (organization_id: number): Promise<any> => {
  return http.get(`/ApprovalRequest/GetByOrganizationId?organization_id=${organization_id}`);
};

export const getApprovalRequestsByOperator = (operator_id: number): Promise<any> => {
  return http.get(`/ApprovalRequest/GetByOperatorId?operator_id=${operator_id}`);
};

export const getApprovalRequestsByStatus = (status: string): Promise<any> => {
  return http.get(`/ApprovalRequest/GetByStatus?status=${status}`);
};